'use client'
import Cookies from 'js-cookie'

// Note: HttpOnly cannot be set client-side. The auth_token JWT cookie is set HttpOnly by the server.
// User profile is served via GET /auth/me using the HttpOnly auth_token cookie.
// Use useUserContext() to access user profile data throughout the app.

const getUserObjData = (objName: string) => {
  let userDataObj: any = Cookies.get(objName)
  try {
    userDataObj = userDataObj ? JSON.parse(userDataObj) : null
  } catch (e) {
    userDataObj = null
  }
  return userDataObj
}

const setUserObjData = (obj: any, objName: string) => {
  const data = JSON.stringify(obj)
  Cookies.set(objName, data, { secure: true, path: '/', sameSite: 'strict' })
}

const removeUserObjData = (objName: string) => {
  Cookies.remove(objName)
}

const checkIsLoggedIn = () => {
  const userTncConsent = getUserObjData('tnc')
  return !!userTncConsent?.privacy && !!userTncConsent?.terms
}

export { getUserObjData, setUserObjData, removeUserObjData, checkIsLoggedIn }
